<template>
  <div id="boton-aplicacion">
    <v-container grid-list-xl fluid>
      <v-layout>
        <v-flex lg12>
          <v-card>
            <boton-proceso-tab-ap :lstBtn="lstBtn"></boton-proceso-tab-ap>
          </v-card>
          <div v-if="loading">
            <loading></loading>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import MiniStatistic from "@/components/widgets/statistic/MiniStatistic";
import Material from "vuetify/es5/util/colors";
import BotonProcesoTabAp from "@/modules/configuration/commonsviews/BotonProcesoTabAp.vue";
import Loading from "@/views/ui/Loading.vue";
export default {
  name: "boton-aplicacion",

  components: {
    MiniStatistic,
    BotonProcesoTabAp,
    Loading,
  },
  props: {
    contratoId: "",
  },
  data: () => ({
    color: Material,
    iconoBoton: "fa-print",
    tituloBoton: "Aplicacion",
    colorBoton: "yellow darken-4",
    lstBtn: [],
    lstBtnCompleta: [
      {
        icon: "fa-print",
        title: "Recepción",
        subtitle: "",
        color: "yellow darken-3",
        class: "recepcion rombo elevation-10",
        subPro: "RECEPCION",
        tab: "Recepcion",
      },
      {
        icon: "all_inbox",
        title: "Selección",
        subtitle: "",
        color: "purple darken-2",
        class: "seleccion rombo elevation-10",
        subPro: "SELECCION",
        tab: "Reclutados",
      },
      {
        icon: "event_note",
        title: "Centros",
        subtitle: "",
        color: "teal",
        class: "centros-ap rombo elevation-10",
        subPro: "CENTROS-AP",
        tab: "Acopio",
      },
      {
        icon: "streetview",
        title: "Revisión",
        subtitle: "",
        color: "light-green darken-2",
        class: "revision rombo elevation-10",
        subPro: "REVISION",
        tab: "Registro Avances",
      },
      {
        icon: "local_shipping",
        title: "Traspaso",
        subtitle: "CA-CO",
        color: "blue darken-3",
        class: "traspaso rombo elevation-10",
        subPro: "TRASPASO",
        tab: "Cronograma",
      },
      {
        icon: "today",
        title: "Visita",
        subtitle: "",
        color: "yellow darken-3",
        class: "visita rombo elevation-10",
        subPro: "VISITA",
        tab: "Agendar Visita",
      },
      {
        icon: "widgets",
        title: "Acomodación",
        subtitle: "",
        color: "purple darken-2",
        class: "acomodacion rombo elevation-10",
        subPro: "ACOMODACION",
        tab: "Ingreso Acomodaciones",
      },
      {
        icon: "fa-edit",
        title: "Aplicación",
        subtitle: "",
        color: "teal",
        class: "aplicacion rombo elevation-10",
        subPro: "APLICACION",
        tab: "Resumen cobertura Aplicación",
      },
      {
        icon: "local_shipping",
        title: "Traspasos",
        subtitle: "CO-CA",
        color: "light-green darken-2",
        class: "traspasos rombo elevation-10",
        subPro: "TRASPASOS",
        tab: "Cronograma",
      },
      {
        icon: "fa-list",
        title: "Retorno",
        subtitle: "",
        color: "blue darken-3",
        class: "captura rombo elevation-10",
        subPro: "RETORNO",
        tab: "Planificación",
      },
      {
        icon: "business",
        title: "Administración",
        subtitle: "",
        color: "yellow darken-3",
        class: "administracion rombo elevation-10",
        subPro: "ADMINISTRACION",
        tab: "Administración",
      },
      {
        icon: "all_inbox",
        title: "Prod&Report",
        subtitle: "",
        color: "purple darken-2",
        class: "reportes rombo elevation-10",
        subPro: "REPORTES",
        tab: "Productos",
      },
    ],
  }),
  created() {
    this.loadDataPanelControl();
  },
  computed: {},
  Mounted() {},
  methods: {
    async loadDataPanelControl() {
      this.loading = true;
      let lstBtnTmp = await this.loadPanelControl();
      for (let i = 0; i < lstBtnTmp.length; i++) {
        this.lstBtn.push(this.lstBtnCompleta[lstBtnTmp[i] - 1]);
      }
      this.loading = false;
    },
    async loadPanelControl() {
      return await axios
        .get(
          "/panelControl/posicionActivos/" + this.$store.getters.contratoStored
        )
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          console.log("error loadPanelControl:" + error);
        });
    },
  },
};
</script>
